import { Col, Form, Input, InputNumber, Row, Switch } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { useContext, useEffect, useRef } from 'react'
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import WebEditUniversal, { WEUExtendPropsType } from '../../system/WebEditUniversalNewEx';
import { SocketContext } from '../../../App';

export default function QueuingSettingEdit(props: any) {

    const [form] = Form.useForm(); //form 
    const { data } = props;
    const ref = useRef<any>(undefined);
    
    const useContextData = useContext(SocketContext);
    const { contextData, setContextData } = useContextData;

    // const [branchStoreData, setBranchStoreData] = useState<any>();

    const handleOk = (e: any) => {
        ref.current.handleOk();
    };

    const handleCancel = (e: any) => {
        ref.current.handleCancel();
    };

    /** 后端数据wmService */
    let wmService: any = "";

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            wmService = ref.current.wmService;
            // form.setFieldsValue({ branchStoreId: localStorage.getItem("currentBranchStoreId") });
            form.setFieldsValue({ branchStoreId: contextData?.currentBranchStoreId });
        }
        const fetchData = async () => {

        }
        fetchData()
    }, [])

    let extendProps: WEUExtendPropsType = {
        ...props,
        form,
        apiId: 'queuingSetting',
        mountDataOptions: {
            userMount: {
                isDept: true
            }
        }
    };

    return (
        <>
            <WebEditUniversal ref={ref} props={extendProps} />
            <AntDraggableModal
                title={(data.type === 'NEW' ? '新增' : '编辑') + '排队设置'}
                open={true}
                okText='确定'
                cancelText='取消'
                onOk={handleOk}
                onCancel={handleCancel}
                closable={false}
                maskClosable={false}
                width={800}
            >
                <Form
                    form={form}
                    initialValues={{ "earlyTime": 0, "delayedTime": 0 }}
                    name="Edit"
                    onFinish={handleOk}
                >
                    <Row gutter={[8, 0]}>
                        <Col span={24}>
                            <Form.Item
                                label="id"
                                name="id">
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        <Col span={0}>
                            <Form.Item
                                label="门店Id"
                                name="branchStoreId"
                            >
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="排队规则"
                                name="rules"
                                rules={[{ required: true, message: '请输入排队规则!' }]}
                            >
                                <TextArea
                                    placeholder="排队规则"
                                    autoSize={{ minRows: 2, maxRows: 5 }}
                                />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;叫号规则【标识】：[@queuingNum]：排队序列;
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="叫号规则"
                                name="callRules"
                                rules={[{ required: true, message: '请输入叫号规则!' }]}
                            >
                                <TextArea
                                    placeholder="叫号规则"
                                    autoSize={{ minRows: 2, maxRows: 15 }}
                                />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;查看排队进程链接【标识】：[@qrCodeId]：二维码id;
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="排队进程链接"
                                name="link"
                                rules={[{ required: true, message: '请输入排队进程链接!' }]}
                            >
                                <Input
                                    placeholder="http://menu.shnoble.com/?qrCodeId=[@qrCodeId]：二维码id;"
                                />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="扫码描述"
                                name="scanDescribe"
                                rules={[{ required: true, message: '请输入扫码描述!' }]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="备注"
                                name="memo">
                                <TextArea
                                    placeholder="备注"
                                    autoSize={{ minRows: 2, maxRows: 5 }}
                                />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="叫号声音链接"
                                name="voiceUrl"
                                rules={[{ required: true, message: '请输入叫号声音链接!' }]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="提前取号时间"
                                name="earlyTime">
                                <InputNumber placeholder="设置提前拿号时间" min={0} addonAfter={"分钟"} />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="延迟叫号时间"
                                name="delayedTime">
                                <InputNumber placeholder="设置延迟叫号时间" min={0} addonAfter={"微秒"} />
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item
                                label="微信取号"
                                name="isWx"
                                valuePropName="checked"
                                initialValue={false}>
                                <Switch checked={false}
                                    checkedChildren="启用"
                                    unCheckedChildren="关闭" />
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item
                                label="跨市别取号"
                                name="isMoreDay"
                                valuePropName="checked"
                                initialValue={false}>
                                <Switch checked={false}
                                    checkedChildren="启用"
                                    unCheckedChildren="关闭" />
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item
                                label="状态"
                                name="isUse"
                                valuePropName="checked"
                                initialValue={true}>
                                <Switch checked={true}
                                    checkedChildren="启用"
                                    unCheckedChildren="关闭" />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </AntDraggableModal>
        </>
    )
}